<style>
.task{
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  //margin-bottom: 10px;
  border-radius: 1rem;
  width: 400px;
  //position: absolute;
  height: fit-content;
  display: flex;
  //justify-content: center;
  align-items: start;
  flex-direction: column;
  overflow: hidden;
  text-align: left;
  position: relative;
}
.task p{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
  width: 100%;
}


.task b{
  display: block;
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
  width: 100%;
}
.task.PROGRAMMATO{
  border: 1px solid #ebe9e9;
  background-color: #ebe9e9;
}
.task.categoria-SUPPORT{
  border: 1px solid var(--bs-primary);;
}
p.small{
  font-size: 12px;
}
.icona{
  position: absolute;
  top: 10px;
  right: 10px;

  height: 35px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}
.icona.rifiutato{
  background: var(--bs-primary);
}
.icona .pi{
  font-size: 20px;
  color: #fff;
}
</style>

<template>

  <div :title="taskEntity.titoloLavoro?'Lavoro: ' +taskEntity.titoloLavoro+'\nAttività: '+taskEntity.titoloAttivita+' - '+taskEntity.idTicket+'\nDOD: '+taskEntity.descrizione:'Attività: '+taskEntity.titoloAttivita+' - '+taskEntity.idTicket+'\nDOD: '+taskEntity.descrizione" @click="oneClick" class="task"
       :class="[taskEntity.tag,  'categoria-'+taskEntity.categoria]" draggable="true" @dragstart="startDrag($event, taskEntity)"
       :style="{ top: taskEntity.style.top, left: taskEntity.style.left }" :id="'task-entity-'+taskEntity.id" v-show="filtro(taskEntity)">
    <div class="icona rifiutato" v-show="taskEntity.tag==='RIFIUTATO'" :title="'Messaggio del PM: '+taskEntity.messaggio">
      <div class="pi pi-exclamation-triangle"></div>
    </div>
    <template v-if="taskEntity.status==='TODO'">
      <template v-if="taskEntity.effortEvaluation===undefined||taskEntity.effortEvaluation===''||taskEntity.effortEvaluation==='NOT_EVALUATED'">
      <div class="d-flex align-items-center gap-2">
        <i class="pi pi-check"></i>
        <p class="small mb-0"><a href="#" @click="approvaStima(taskEntity,allowFeedbackTs)">Confermo la stima</a></p>
      </div>
      <div class="d-flex align-items-center gap-2">
        <i class="pi pi-times"></i>
        <p class="small mb-0"><a href="#" @click="rifiutaStima(taskEntity,allowFeedbackTs)">Rifiuto la stima</a></p>
      </div>
      </template>
      <template v-if="taskEntity.effortEvaluation==='CONFIRMED'||taskEntity.effortEvaluation==='REFUSED'">
        <div class="d-flex align-items-center gap-2">
          <i v-if="taskEntity.effortEvaluation==='CONFIRMED'" class="pi pi-thumbs-up"></i>
          <i v-if="taskEntity.effortEvaluation==='REFUSED'" class="pi pi-exclamation-triangle"></i>
          <p class="small mb-0">{{getDescriptionStima(taskEntity)}}</p>
        </div>
        <div class="d-flex align-items-center gap-2">
          <i :class="{ 'pi pi-cog': (taskEntity.startWorkingTS===undefined || taskEntity.startWorkingTS<=0), 'pi pi-info': taskEntity.startWorkingTS>0 }" :title="'Stima '+taskEntity.effortEvaluation+' il '+taskEntity.effortEvaluationTS" ></i>
          <p v-if="taskEntity.startWorkingTS===undefined || taskEntity.startWorkingTS<=0" class="small mb-0"><a href="#" @click="notificaStartWorking(taskEntity,allowFeedbackTs)">Inizio a lavorarci</a></p>
          <p v-if="taskEntity.startWorkingTS>0" class="small mb-0">In corso dal {{getDescriptionStartWorking(taskEntity)}}</p>
        </div>
        <div v-if="taskEntity.startWorkingTS>0" class="d-flex align-items-center gap-2">
          <i :class="{ 'pi pi-clock': (taskEntity.effortRevisionRequestedTS===undefined || taskEntity.effortRevisionRequestedTS<=0), 'pi pi-exclamation-triangle': taskEntity.effortRevisionRequestedTS>0 }" class="pi pi-clock" ></i>
          <p v-if="(taskEntity.effortRevisionRequestedTS===undefined || taskEntity.effortRevisionRequestedTS<=0)"   class="small mb-0"><a href="#" @click="richiediAltroTempo(taskEntity,allowFeedbackTs)">Mi serve altro tempo!</a></p>
          <p v-if="taskEntity.effortRevisionRequestedTS>0"  class="small mb-0" :title="formatTime(taskEntity.effortRevisionRequestedTS)">altro tempo richiesto il {{formatTime(taskEntity.effortRevisionRequestedTS)}} </p>
        </div>
      </template>
    <br/>
    </template>

    <b v-if="taskEntity.titoloLavoro">Lavoro: {{ taskEntity.titoloLavoro }} </b>
    <b v-if="taskEntity.titoloAttivita">Attività: {{ taskEntity.titoloAttivita }} - {{ taskEntity.idTicket }}</b>
    <b v-if="taskEntity.labelAnagraficaRelazione">Anagrafica: {{ taskEntity.labelAnagraficaRelazione }}</b>
    <b v-if="taskEntity.nomePM && taskEntity.status==='REVIEW'">PM - Responsabile: {{ taskEntity.forcePM?getEsecutore(taskEntity.idPmForzato):taskEntity.nomePM }}</b>
    <p>{{ taskEntity.descrizione}}</p>
    <p class="small">Carico: {{ taskEntity.orePreviste}}h</p>

<!--
    <div class="d-flex align-items-center gap-2 mt-2">
      <i class="pi pi-cog"></i>
      <p class="small mb-0">Ho iniziato a lavorarci</p>
    </div>
-->
  </div>

</template>

<script>
import * as $ from "jquery";
import moment from "moment";


export default {
  name: "KTask",
  props: {
    taskEntity: {
      type: Object,
      default:null
    },
    allowFeedbackTs: {
      type: Boolean,
      default: true,
    },
    isPM:{
      type: Boolean,
      default:false
    },
    permettiHover:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return {
      timerHover:null,
      clicks: 0,
      delay: 700,
      timer: null,
      filtriClient:null
    }
  },
  created() {
    this.$store.subscribe(async (mutation, state) => {
      if(mutation.type==='updateTaskPosition'){
        if(mutation.payload.id===this.taskEntity.id){
          $('#task-entity-'+this.taskEntity.id).css({
            top:mutation.payload.top,
            left:mutation.payload.left
          });
        }
      }
      if (mutation.type === 'filtraTasks'){
        this.filtriClient=mutation.payload;
      }
    })
  },
  methods: {
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('element', JSON.stringify(item))
    },
    onDrop(evt, list) {
      const itemID = evt.dataTransfer.getData('itemID')
      const item = this.items.find((item) => item.id === itemID)
      item.list = list
    },
    handleClick (event, item) {
      this.$refs.vueSimpleContextMenu.showMenu(event, item)
    },
    optionClicked (event) {
      window.alert(JSON.stringify(event))
    },
    getDescriptionStartWorking(taskEntity){
      return moment.unix(taskEntity.startWorkingTS).format("DD/MM/YYYY HH:mm");
    },
    formatTime(ts){
      return moment.unix(ts).format("DD/MM/YYYY HH:mm");
    },
    getDescriptionStima(taskEntity){
      let res="Stima ";
      if(taskEntity.effortEvaluation==="CONFIRMED"){
        res+=" confermata ";
      }
      if(taskEntity.effortEvaluation==="REFUSED"){
        res+=" rifiutata ";
      }
      res+=" il "+moment.unix(taskEntity.effortEvaluationTS).format("DD/MM/YYYY HH:mm");
      return res;
    },
    notificaStartWorking(taskEntity,allowFeedbackTs){
      if(!allowFeedbackTs){
        alert('Questa azioone può essere fatta solo dall\'utente nella sua dashboard');
        return ;
      }
      console.log("notificaStartWorking la stima",taskEntity);
      this.$store.dispatch('notificaStartWorking',{
        id:taskEntity.id
      });
    },
    richiediAltroTempo(taskEntity,allowFeedbackTs){
      if(!allowFeedbackTs){
        alert('Questa azioone può essere fatta solo dall\'utente nella sua dashboard');
        return ;
      }
      console.log("richiedo altro tempo",taskEntity);
      this.$store.dispatch('requestEffortRevision',{
        id:taskEntity.id
      });
    },
    approvaStima(taskEntity,allowFeedbackTs){
      if(!allowFeedbackTs){
        alert('Questa azioone può essere fatta solo dall\'utente nella sua dashboard');
        return ;
      }
      console.log("approvo la stima",taskEntity);
      this.$store.dispatch('updateEffortEvaluation',{
        id:taskEntity.id,
        effortEvaluation:'CONFIRMED'
      });
    },
    rifiutaStima(taskEntity,allowFeedbackTs){
      if(!allowFeedbackTs){
        alert('Questa azioone può essere fatta solo dall\'utente nella sua dashboard');
        return ;
      }
      console.log("rifiuto la stima",taskEntity);

      this.$store.dispatch('updateEffortEvaluation',{
        id:taskEntity.id,
        effortEvaluation:'REFUSED'
      });
    },
    oneClick(event) {
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout( () => {
          if(event&&this.result){
            this.result.push(event.type);
          }
          this.clicks = 0
        }, this.delay);
      } else {
        //Doppio click
        clearTimeout(this.timer);
        //this.$store.dispatch('editTaskDOD', {...this.taskEntity});
        //this.$store.dispatch('showDettaglioTicket', {...this.taskEntity});
        let ticket=this.$store.getters.getTicket(this.taskEntity.idTicket);
        if(ticket===false && this.isPM){
          this.$store.dispatch('addMessage', {
            message:"Dettagli ticket ancora in caricamento, attendere qualche istante",
            messageType:'info'
          });
        }
        let lavoro=this.$store.getters.getLavoroTicket(this.taskEntity.idTicketParent);
        if(lavoro===false  && this.isPM){
          this.$store.dispatch('addMessage', {
            message:"Dettagli ticket ancora in caricamento, attendere qualche istante",
            messageType:'info'
          });
        }
        if((lavoro && ticket)|| !this.isPM){
          console.log("ho cliccato un ts:",ticket);
          this.$store.dispatch('startShowDettaglioTicket', {
            task:this.taskEntity,
            titoloTicket:ticket[0]?.titolo,
            descrizioneTicket:ticket[0]?.descrizione,
            titoloLavoro:lavoro[0]?.titolo,
            idTicketLavoro:lavoro[0]?.id_ticket,
            descrizioneLavoro:lavoro[0]?.descrizione,
            isPM:this.isPM,
          });
        }
        this.clicks = 0;
      }
    },
    mouseHover(){
      // this.timerHover=setTimeout(()=>{
      //   let ticket=this.$store.getters.getTicket(this.taskEntity.idTicket);
      //   let lavoro=this.$store.getters.getLavoroTicket(this.taskEntity.idTicketParent);
      //   if(lavoro && ticket && this.permettiHover){
      //     this.$store.dispatch('startShowDettaglioTicket', {
      //       task:this.taskEntity,
      //       titoloTicket:ticket[0]?.titolo,
      //       descrizioneTicket:ticket[0]?.descrizione,
      //       titoloLavoro:lavoro[0]?.titolo,
      //       descrizioneLavoro:lavoro[0]?.descrizione,
      //       isPM:this.isPM,
      //     });
      //   }
      // }, 1000)
    },
    mouseLeave(){
      clearTimeout(this.timerHover);
    },
    filtro(task){
      this.filtriClient=this.$store.getters.getFiltriApplicati()
      if(!this.filtriClient || (this.filtriClient?.idEsecutore===-1 && this.filtriClient?.idLavoro===-1 && this.filtriClient?.idAttivita===-1))
        return true
      else{
        if(this.filtriClient.idLavoro!==-1 && this.filtriClient.idAttivita===-1){
          //FILTTRO SOLO PER LAVORO
          return task.idTicketParent==this.filtriClient.idLavoro;
        }
        if(this.filtriClient.idLavoro===-1 && this.filtriClient.idAttivita!==-1){
          //FILTTRO SOLO PER ATTIVITA
          return task.idTicket==this.filtriClient.idAttivita;
        }
        if(this.filtriClient.idLavoro!==-1 && this.filtriClient.idAttivita!==-1){
          //FILTTRO PER LAVORO E ATTIVITA
          return (task.idTicket==this.filtriClient.idAttivita && task.idTicketParent==this.filtriClient.idLavoro);
        }
      }
    },

    getEsecutore(idEsecutore){

      let esecutore=this.$store.getters.getEsecutoriFilter(""+idEsecutore);
      if(!esecutore || esecutore.length <= 0){
        return ''
      }else{
        return esecutore[0].descrizione;
      }
    },

  }
}
</script>